import { Switch, SwitchProps } from 'antd';

const MfaSwitch = (props: SwitchProps) => {
  return (
    <div>
      <span style={{ marginRight: 10 }}>Multi-Factor Authentication</span>
      <Switch {...props} />
    </div>
  );
};

export default MfaSwitch;
